"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = exports.OfferTitle = exports.CompanyName = exports.OfferInfo = exports.Offer = exports.CompanyImageWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.CompanyImageWrapper = (0, styled_components_1.default)(elements_1.Link) `
	position: relative;
	${(0, styled_breakpoints_1.down)('md')} {
		margin: 0.5rem 0;
	}
`;
exports.Offer = styled_components_1.default.div `
	padding: 1rem;
	display: flex;
	justify-content: space-between;

	${(0, styled_breakpoints_1.down)('sm')} {
		flex-direction: column;
	}
`;
exports.OfferInfo = styled_components_1.default.div `
	display: flex;
	justify-content: space-between;
	flex: 1;

	${(0, styled_breakpoints_1.down)('md')} {
		flex-direction: column;
	}
`;
exports.CompanyName = (0, styled_components_1.default)(elements_1.Link) `
	&& {
		color: ${({ theme }) => theme.color.gray6};
		font-weight: bold;
		font-size: 1rem;

		&:hover {
			color: ${({ theme }) => (0, polished_1.transparentize)(0.3, theme.color.gray6)};
		}
	}
`;
exports.OfferTitle = (0, styled_components_1.default)(elements_1.Link) `
	font-size: 1.4rem;
	color: ${({ theme }) => theme.color.brand1};
	font-weight: 500;
	margin-bottom: 0.25rem;

	&:hover {
		color: ${({ theme }) => (0, polished_1.transparentize)(0.3, theme.color.brand1)};
	}
`;
exports.ButtonGroup = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: end;
	max-width: 300px;

	${(0, styled_breakpoints_1.up)('md')} {
		margin-left: 1rem;
	}

	${(0, styled_breakpoints_1.down)('sm')} {
		align-self: center;
		width: 100%;
	}
`;
